import type {
  DashboardByDateEntry,
  DashboardProjectEntry,
  DashboardTopItem,
  TeamActivityEntry,
} from 'api/types/dashboard.types';

export type { DashboardByDateEntry, DashboardProjectEntry, DashboardTopItem, TeamActivityEntry };

export type DashboardChartMode = 'Billability' | 'Project';
export const DASHBOARD_CHART_MODES: DashboardChartMode[] = ['Billability', 'Project'];

export interface DashboardDateRange {
  from: string;
  to: string;
  label: string;
}
